import { MissionType, SiteType } from "@/types";
import { FeatureCollection } from "geojson";

const init: RequestInit = {
  method: "GET",
  mode: "cors",
  headers: { "Content-Type": "application/json" },
};

const fetchData = async <T>(endpoint: string): Promise<T> => {
  return await fetch(endpoint, { ...init, cache: "no-cache" })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      return response.json();
    })
    .then((result) => {
      if (result.stat === "fail") {
        throw new Error(result.message);
      }
      return result;
    })
    .catch((error) => console.error(error));
};

/**
 * fetchSites
 * @description Get a collection of sites
 * @return SiteType[]
 */
export const fetchSites = async (): Promise<SiteType[]> => {
  return fetchData<SiteType[]>(
    "https://data.oreme.org/gpsmob/gpsmob_map/get_sites",
  );
};

/**
 * fetchPrivateSites
 * @description Get a collection of sites
 * @return SiteType[]
 */
export const fetchPrivateSites = async (): Promise<SiteType[]> => {
  return fetchData<SiteType[]>(
    "https://data.oreme.org/gpsmob/gpsmob_map/get_sites/private",
  );
};

/**
 * fetchGeoSites
 * @description Get a collection of sites
 * @return FeatureCollection
 */
export const fetchGeoSites = async (): Promise<FeatureCollection> => {
  return fetchData(
    "https://sig.oreme.org/geoserver/sf/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sf:gpsmob_site&outputFormat=application/json",
  );
};

/**
 * fetchPrivateGeoSites
 * @description Get a collection of unpublished sites
 * @return FeatureCollection
 */
export const fetchPrivateGeoSites = async (): Promise<FeatureCollection> => {
  return fetchData(
    "https://sig.oreme.org/geoserver/sf/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=sf:gpsmob_site_private&outputFormat=application/json",
  );
};

/**
 * fetchMissions
 * @description Get a collection of missions
 * @return MissionType[]
 */
export const fetchMissions = async (): Promise<MissionType[]> => {
  return fetchData<MissionType[]>(
    `https://data.oreme.org/gpsmob/gpsmob_map/get_missions`,
  );
};

/**
 * fetchMissions
 * @description Get a collection of missions
 * @return MissionType[]
 */
export const fetchPrivateMissions = async (): Promise<MissionType[]> => {
  return fetchData<MissionType[]>(
    `https://data.oreme.org/gpsmob/gpsmob_map/get_missions/private`,
  );
};
